

import axios from 'axios';

import serveradresse_settings from '@/settings/serveradresse_settings.js';
const url = serveradresse_settings.config_server_adresse.url;


export default {
  
  async zeigecheckpunkte(credentials) {
    return axios
      .post(url + 'checkpunkte_anzeigen/', credentials)
      .then(response => response.data);
  },


};